// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"c536d9f9","185":"96b41114","255":"7dbf33cb","334":"a74f11c0","639":"0de9caf8"}[chunkId] + ".css";
};